export default "__VITE_ASSET__Def_I1SC__"